import * as React from 'react';
export const IcCallEmergency = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.62 15.86c-.78-.78-2.05-.78-2.83 0l-.71.71c-.71.71-1.41 0-1.41 0l-4.24-4.24c-.71-.71 0-1.41 0-1.41l.71-.71c.78-.78.78-2.05 0-2.83l-.71-.71c-.78-.78-2.05-.78-2.83 0l-.99.99c-.31.31-.51.7-.57 1.14-.17 1.41-.06 4.74 3.68 8.48s7.08 3.85 8.48 3.68c.43-.05.83-.26 1.14-.57l.99-.99c.78-.78.78-2.05 0-2.83l-.71-.71zM16.5 2C13.46 2 11 4.46 11 7.5V13h5.5c3.04 0 5.5-2.46 5.5-5.5S19.54 2 16.5 2zm3 6c0 .28-.22.5-.5.5h-1.5V10c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5V8.5H14c-.28 0-.5-.22-.5-.5V7c0-.28.22-.5.5-.5h1.5V5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1.5H19c.28 0 .5.22.5.5v1z'
      fill='currentColor'
    />
  </svg>
);
